<div #wrapper class="upgrade-wrapper">
    <div class="modal-body">
        <div class="logo-body">
            <img class="logo" src="assets/images/logo.svg" alt="agaia logo"/>

            <i class="close-shortcuts ti-close" (click)="bsModalRef.hide()"></i>
        </div>

        <div class="shortcuts" *ngIf="currentlySelectedDailyMeal">
            <div
                    *ngFor="let meal of currentlySelectedDailyMeal.meals"
                    (click)="onClickMeal(meal)"
                    class="shortcut-action animated fadeIn delay-3">
                <div class="shortcut-image">
                    <img *ngIf="isBreakfast(meal.title)" src="assets/images/breakfast.png"/>
                    <img *ngIf="isLunch(meal.title)" src="assets/images/lunch.png"/>
                    <img *ngIf="isDinner(meal.title)" src="assets/images/dinner.png"/>
                    <img *ngIf="isSnack(meal.title)" src="assets/images/mejdinno.png"/>
                </div>

                <div class="shortcut-text">
                    <h3 class="shortcut-title">{{ meal.title }}</h3>
                </div>

                <div class="clear"></div>
            </div>

            <div *ngIf="hideAutoLoadRecipes === false" (click)="onClickBasicMealEvent('load_recipes')" class="shortcut-action animated fadeIn delay-3">
                <div class="shortcut-image">
                    <i class="ti-reload"></i>
                </div>

                <div class="shortcut-text">
                    <h3 class="shortcut-title">{{ 'load_recipes' | localise }}</h3>
                </div>

                <div class="clear"></div>
            </div>

            <div (click)="onClickBasicMealEvent('external_meals')" class="shortcut-action animated fadeIn delay-3">
                <div class="shortcut-image">
                    <i class="fa-th-list fa"></i>
                </div>

                <div class="shortcut-text">
                    <h3 class="shortcut-title">{{ 'external_meals' | localise }}</h3>
                </div>

                <div class="clear"></div>
            </div>

            <div (click)="onClickBasicMealEvent('shopping_list')" class="shortcut-action animated fadeIn delay-3">
                <div class="shortcut-image">
                    <i class="mdi mdi-shopping"></i>
                </div>

                <div class="shortcut-text">
                    <h3 class="shortcut-title">
                        {{ 'shopping_list' | localise }}
                    </h3>
                </div>

                <div class="clear"></div>
            </div>

            <div (click)="onClickBasicMealEvent('diary_training')" class="shortcut-action animated fadeIn delay-3">
                <div class="shortcut-image">
                    <i class="mdi mdi-dumbbell"></i>
                </div>

                <div class="shortcut-text">
                    <h3 class="shortcut-title">
                        {{ 'diary_training' | localise }}
                    </h3>
                </div>

                <div class="clear"></div>
            </div>

            <div (click)="onClickBasicMealEvent('daily_changes_activities')" class="shortcut-action animated fadeIn delay-3">
                <div class="shortcut-image">
                    <i class="mdi mdi-weight"></i>
                </div>

                <div class="shortcut-text">
                    <h3 class="shortcut-title">
                        {{ 'dashboard_extra_load_long' | localise }}
                    </h3>
                </div>

                <div class="clear"></div>
            </div>
        </div>
    </div>
</div>
